<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:submitted_at" slot-scope="row">
                                {{row.item.submitted_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Safety Inspection Checklist" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown
                            vLabel="contract_title"
                            label="Project" 
                            :filterable="false" 
                            :required="true"
                            :show-icon-required="true"
                            :options="modals.add.options.scontracts"
                            @search="searchContract"
                            v-model="modals.add.data.project" >
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <span>{{ option.contract_title || '--' }}</span>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <span v-b-tooltip.hover.topleft="{
                                    title: option.contract_title
                                }">{{ option.contract_title || '--' }}</span>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Equipment Tag"
                            v-model="modals.add.data.equipment"
                            vLabel="tag_name"
                            :required="true"
                            :show-icon-required="true"
                            :options="modals.add.options.equipments"
                            @search="searchEquipment"
                            :clearable="false" 
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Participating Inspectors"
                            vLabel="name"
                            :filterable="false"
                            :append-to-body="true"
                            :options="modals.add.options.inspectors"
                            @search="searchUsers"
                            v-model="modals.add.data.inspector">
                            <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                            <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-supplier
                            label="Subcontractor"
                            :contract-id="ClientContractID && ClientContractID.id ? ClientContractID.id : null"
                            :required="true"
                            v-model="modals.add.data.company">
                        </gofix-form-supplier>
                        <gofix-form-dropdown
                            label="Project Manager"
                            vLabel="name"
                            :filterable="false"
                            :append-to-body="true"
                            :options="modals.add.options.project_managers"
                            @search="searchUserManagers"
                            v-model="modals.add.data.project_manager">
                            <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                            <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                {{option.user_name}} - {{option.user_email}}
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Checklist template"
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            :filterable="false"
                            :required="true"
                            :show-icon-required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="modals.add.data.checklist_template_id"
                            :options="modals.add.options.checklist_templates">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
export default {
    name: 'SafetyInspectionChecklist',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_inspection_checklist']));
        return {
            tableConfig:{
                name: 'safety-inspection-checklist-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.safety_inspection_checklist, 'create'),
                    delete: this.$checkRole(this.$accessModule.safety_inspection_checklist, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Contractor Acknowledged', text: 'Contractor Acknowledged'},
                            {value: 'Completed', text: 'Completed'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        inspector: null,
                        company: null,
                        checklist_template_id: null,
                        project_manager: null
                    },
                    options: {
                        scontracts: [],
                        equipments: [],
                        inspectors: [],
                        project_managers: [],
                        checklist_templates: []
                    }
                }
            },
            pagesEquipment: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            timer: {
                equipment: null,
                scontracts: null,
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getSafetyInspectionChecklistItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of users", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
           this.$router.push(`/v2/safety-inspection-checklist/${item.id}`)
        },
        newItem() {
            if(!this.ClientContractID || !this.ClientContractID.id) {
                return this.$alertNotification("Please select a contract before create safety inspection.", "warning");
            }
            this.getSContracts();
            this.getEquipments();
            this.getChecklistTemplates();
            this.loadUser();
            this.loadUserManager();
            this.modals.add.data = {
                project: null,
                equipment: null,
                inspector: null,
                companies: null
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyInspectionItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safe_inspection_checklist'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },

        async getSContracts() {
            if(!this.ClientContractID || !this.ClientContractID.id) {
                this.modals.add.options.scontracts = []
                return
            }
            let tableRequest = {
                filter: { client_contract_id: this.ClientContractID.id },
                page: 1,
                limit: -1
            }

            await this.$store.dispatch("SContractProjectController/getSContract", tableRequest)
                .then(response => {
                    this.modals.add.options.scontracts = response.items;
                })
                .catch(err => {})
        },
        async getEquipments(search = "") {
            if(this.ClientContractID && this.ClientContractID.id) {
                // this.loading.equipment = true;
                this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                this.pagesEquipment.filter.tag_name.value = search;
                this.pagesEquipment.filter.contract_id.value = this.ClientContractID.id;

                await this.$store.dispatch("EquipmentV2Controller/getEquipmentsOfLiftInspectionCalendar", this.pagesEquipment)
                .then(response => {
                    // this.loading.equipment = false;
                    this.modals.add.options.equipments = response.data.data.items;
                })
                .catch(err => {
                    // this.loading.equipment = false;
                    console.log(err)
                })
            }
        },
        async getChecklistTemplates(){
            this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [
                1000, 1, {contract_id: this.ClientContractID.id}
            ])
            .then(response => {
                this.modals.add.options.checklist_templates = response.data.data.items;
            })
            .catch(err => {
                this.modals.add.options.checklist_templates = [];
            });
        },
        async searchContract(search, loading) {
            loading(true)
            this.modals.add.options.scontracts = []
            if (this.timer.scontracts) {
                clearTimeout(this.timer.scontracts);
                this.timer.scontracts = null;
            }
            this.timer.scontracts = setTimeout(async () => {
                try {
                    await this.getSContracts(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async searchEquipment(search, loading) {
            loading(true)
            this.modals.add.options.equipments = []
            if (this.timer.equipment) {
                clearTimeout(this.timer.equipment);
                this.timer.equipment = null;
            }
            this.timer.equipment = setTimeout(async () => {
                try {
                    await this.getEquipments(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        getUserDuty(filter = {}, keyOption) {
            let filterDefault = {
                contract_id:{type:"number",value:this.ClientContractID.id,function:"=",with:[]},
            };

            let filters = Object.assign(filterDefault, filter);

            let request = {
                limit: 100,
                page: 1,
                isCMS:1,
                sortColumn:'user_id',
                sortDirection:'ASC',
                filter: filters,
                useDatabaseView:true
            };
            this.$store.dispatch("UserDutyController/getItems", request)
                .then(result=>{
                    this.modals.add.options[keyOption] = result.items;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        loadUser(search = '') {
            let filter = {
                user_name:{type:"text",value:search,function:"ilike",with:[]},
                user_email:{type:"text",value:search,function:"ilike",with:[]},
                service_category_name:{type:"text",value:"WSH",function:"ilike",with:[]},
            };
            this.getUserDuty(filter, 'inspectors');
        },
        searchUsers(search, loading) {
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.loadUser(search);
                loading(false);
            }, 500);
        },
        loadUserManager(search = null) {
            let filter = {
                user_name:{type:"text",value:search,function:"ilike",with:[]},
                user_email:{type:"text",value:search,function:"ilike",with:[]},
                role_name:{type:"text",value:"Project Manager",function:"ilike",with:[]},
            };
            this.getUserDuty(filter, 'project_managers');
        },
        searchUserManagers(search, loading) {
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.loadUserManager(search);
                loading(false);
            }, 500);
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;
                
                if(!this.modals.add.data.project) {
                    return this.$alertNotification("Please choose a project.", "danger");
                }

                if(!this.modals.add.data.equipment) {
                    return this.$alertNotification("Please choose a equipment.", "danger");
                }

                if(!this.modals.add.data.checklist_template_id) {
                    return this.$alertNotification("Please choose a checklist template.", "danger");
                }

                let objeClone = {
                    client_contract_id: this.ClientContractID.id,
                    checklist_template_id: this.modals.add.data.checklist_template_id,
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.location_name,
                    equipment_id: this.modals.add.data.equipment.id,
                    equipment_lift_number: this.modals.add.data.equipment.lift_name,
                    supplier_id: this.modals.add.data.company && this.modals.add.data.company.id ? this.modals.add.data.company.id : null,
                    supplier: this.modals.add.data.company && this.modals.add.data.company.name ? this.modals.add.data.company.name : null,
                    participating_inspector_by_id: this.modals.add.data.inspector && this.modals.add.data.inspector.id ? this.modals.add.data.inspector.id : null,
                    project_manager_id: this.modals.add.data.project_manager && this.modals.add.data.project_manager.user_id ? this.modals.add.data.project_manager.user_id : null,
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyInspectionItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/safety-inspection-checklist/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'safe_inspection_checklist'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        }
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
.tooltip {
    max-width: 400px;
}
</style>